var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.user.lastName))]},{"user11":_vm.user}),_vm._t("cat",function(){return [_vm._v(_vm._s(_vm.cat.name))]},{"cat11":_vm.cat})],2)}
var staticRenderFns = []

export { render, staticRenderFns }